/*
 *
 * UpperShelf constants constants
 *
 */

enum ActionTypes {
  DISPLAY_UPPERSHELF_PANEL = 'app/UpperShelfPanel/DISPLAY_UPPERSHELF_PANEL',
  ADD_OR_UPDATE_UPPER_SHELF = 'app/UpperShelfPanel/ADD_OR_UPDATE_UPPER_SHELF',
  REMOVE_UPPER_SHELF = 'app/UpperShelfPanel/REMOVE_UPPER_SHELF',
  ADD_OR_UPDATE_FURNITURE_UPPER_SHELF = 'app/UpperShelfPanel/ADD_OR_UPDATE_FURNITURE_UPPER_SHELF',
  REMOVE_FURNITURE_UPPER_SHELF = 'app/UpperShelfPanel/REMOVE_FURNITURE_UPPER_SHELF',
}

export default ActionTypes;
